import type { CheckboxProps, CheckedState } from '@radix-ui/react-checkbox';
import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { CheckIcon } from '@radix-ui/react-icons';

export { CheckboxProps, CheckedState };

export const CheckBox = ({
  className = '',
  checked,
  defaultChecked,
  required,
  onCheckedChange,
  disabled,
  ...props
}: RadixCheckbox.CheckboxProps) => (
  <RadixCheckbox.Root
    className={`focus:ring-indigo-500 flex h-4 w-4 shrink-0 items-center justify-center rounded border border-primary-700 bg-white hover:bg-primary-50 focus:outline-none focus:ring-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary-50 ${className}`}
    checked={checked}
    defaultChecked={defaultChecked}
    required={required}
    onCheckedChange={onCheckedChange}
    disabled={disabled}
    data-testid={props.id}
    {...props}
  >
    <RadixCheckbox.Indicator className="text-primary-600">
      <CheckIcon />
    </RadixCheckbox.Indicator>
  </RadixCheckbox.Root>
);
